export default class ArchiveCatForm {
    private formElement: HTMLFormElement | null;
    private selectElement: HTMLSelectElement | null;

    constructor(formId: string, selectId: string) {
        this.formElement = document.getElementById(formId) as HTMLFormElement | null;
        this.selectElement = document.getElementById(selectId) as HTMLSelectElement | null;

        if (this.formElement && this.selectElement) {
            this.selectElement.onchange = this.handleChange.bind(this);
        }
    }

    private handleChange() {
        if (this.formElement && this.selectElement) {
            const optionVal = this.selectElement.value;
            let newAction = `${window.location.origin}/resources/`;

            if (optionVal) {
                newAction += `category/${optionVal}`;
            }

            this.formElement.action = newAction;
            this.formElement.submit();
        }
    }
}
